module.exports = __webpack_public_path__ + "img/cardFront.fce8a828.png";